import axios from "axios";

import { AXIOS_DEFAULT_CONFIG, routes } from "../../constants";

const getTableRequest = async (id) => {
  const response = await axios.get(
    routes.tableRequest(id),
    AXIOS_DEFAULT_CONFIG
  );
  return response;
};
export default getTableRequest;
